import { useState } from 'react'
import { navigate } from 'gatsby'

export const useSearch = () => {
  let query
  const isBrowser = typeof window !== 'undefined'
  if (isBrowser) {
    query = location.search
  }

  const [searchTerm, setSearchTerm] = useState(
    new URLSearchParams(query).get('q') ?? ''
  )

  const handleChange = (event) => {
    setSearchTerm(event.target.value)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    if (searchTerm.trim() !== '') {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`)
    }
  }

  return {
    searchTerm,
    handleSubmit,
    handleChange,
  }
}
